var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfidentToneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.964,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3252 0.00204451C16.0122 -0.0712668 19.6432 1.827 22.2185 5.69684C24.1699 9.03451 24.5181 12.535 23.2634 16.1982C21.7857 19.8702 19.1647 22.3171 15.4004 23.5388C10.6351 24.7421 6.53383 23.6014 3.09653 20.1167C0.0192892 16.4579 -0.764398 12.3479 0.745469 7.78667C2.36306 3.83583 5.24529 1.33674 9.39215 0.289396C10.0398 0.162909 10.6841 0.0671219 11.3252 0.00204451ZM11.4297 1.72616C15.5639 1.69853 18.7248 3.42265 20.9123 6.89849C22.7583 10.3119 22.7583 13.7253 20.9123 17.1387C18.8663 20.4255 15.8971 22.1496 12.0044 22.311C8.39237 22.199 5.54498 20.6839 3.46225 17.7656C1.59291 14.8279 1.22719 11.7106 2.36509 8.41362C4.06532 4.39785 7.08685 2.1687 11.4297 1.72616Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.958,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3335 7.2642C18.2047 7.25558 18.5443 7.67355 18.3523 8.5181C18.2565 8.68356 18.1259 8.81418 17.9604 8.90994C17.3683 9.20602 16.7762 9.50204 16.1841 9.79812C16.811 10.1116 17.438 10.4251 18.0649 10.7385C18.5297 11.1937 18.5471 11.6639 18.1172 12.1492C17.8374 12.336 17.5413 12.3708 17.229 12.2537C16.0796 11.679 14.9302 11.1043 13.7808 10.5296C13.2448 10.0665 13.2274 9.57885 13.7285 9.06668C14.935 8.46345 16.1366 7.86262 17.3335 7.2642Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.963,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19784 8.10015C8.57279 8.05574 9.24326 8.71754 9.2093 10.0855C8.95403 11.0724 8.31835 11.5338 7.30233 11.47C6.39581 11.2685 5.90815 10.7026 5.83945 9.77201C5.8976 8.88739 6.35041 8.33013 7.19784 8.10015Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30233 15.6235C7.55896 15.6007 7.80274 15.6442 8.03377 15.7542C9.72763 17.8452 11.8001 18.3502 14.251 17.2693C14.8879 16.9285 15.4104 16.4583 15.8184 15.8586C16.2078 15.5672 16.6083 15.5497 17.02 15.8064C17.4022 16.2116 17.4283 16.6383 17.0984 17.0864C15.3048 19.1879 13.0495 19.9454 10.3326 19.3591C8.7802 18.9371 7.56983 18.0577 6.7015 16.7207C6.60391 16.184 6.80422 15.8183 7.30233 15.6235Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfidentToneIcon);
export default __webpack_public_path__ + "static/media/confident_tone_icon.e6d1595f.svg";
export { ForwardRef as ReactComponent };